"use strict";
import classNames from "classnames";
import React from "react";
const RadioButtonGroup = ({ options, label, selectedId, onClickHandler }) => {
  return /* @__PURE__ */ React.createElement("div", { className: "radio-buttons" }, label && /* @__PURE__ */ React.createElement("div", { className: "radio-buttons__label radio-buttons__label--long" }, label), options.map((option) => /* @__PURE__ */ React.createElement("div", { className: "radio-button", key: option.id }, /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames("radio-button__click-field", {
        "radio-button__click-field--is-disabled": option.disabled
      }),
      onClick: () => onClickHandler(option.id)
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames("radio-button__circle", "center", {
          "radio-button__circle--is-selected": selectedId === option.id,
          "radio-button__circle--is-disabled": option.disabled
        })
      },
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: classNames("radio-button__inner-circle", {
            "radio-button__inner-circle--is-selected": selectedId === option.id,
            "radio-button__inner-circle--is-disabled": option.disabled
          })
        }
      )
    ),
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames("radio-button__label", "label", {
          "label--is-disabled": option.disabled
        })
      },
      option.label
    )
  ))));
};
export default RadioButtonGroup;
